module.exports = __webpack_public_path__ + "media/images/favicon-16x16-86ba3e8ca1ab665fbe2c2961e4e6709b.png";